
const digest = '9201a3d10c2c9eaa110a029b94078021891e035dbaf790bcf5905a936ac26bba';
const classes = {"wrapper":"_wrapper_1gzkq_1","title":"_title_1gzkq_6","item":"_item_1gzkq_10","button":"_button_1gzkq_28"};
const css = `._wrapper_1gzkq_1 {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
._wrapper_1gzkq_1 ._title_1gzkq_6 {
  font-size: 16px;
  font-weight: 600;
}
._wrapper_1gzkq_1 ._item_1gzkq_10 {
  background: #e7f5fb;
  border-radius: 15px;
  padding: 16px 24px;
  display: flex;
  flex-direction: row;
  font-weight: 500;
  font-size: 14px;
  gap: 12px;
  border: 1px solid #dee9ff;
  align-items: center;
  justify-content: space-between;
  color: #2f61b2;
}
._wrapper_1gzkq_1 ._item_1gzkq_10 span {
  font-weight: 400;
  color: #000000;
}
._wrapper_1gzkq_1 ._button_1gzkq_28 {
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  